import LoginCard from "./LoginCard";

export { LoginCard };

export default LoginCard;
